<!-- 查看课件 -->
<template>
  <div class="el-coursewareViewing" :class="{ standalone: isStandalone }">
    <!-- 双屏演示：副屏独立窗口只保留顶部工具条 -->
    <div class="standaloneBar" v-if="isStandalone">
      <span class="sbTitle">{{ courseInfoName || "课件预览" }}</span>
      <el-button size="mini" type="text" icon="el-icon-full-screen" @click="toggleFullscreen">全屏</el-button>
      <el-button size="mini" type="text" icon="el-icon-close" @click="closeStandalone">退出</el-button>
    </div>
    <el-row class="content_block mb20">
      <TitleInfo v-if="!isStandalone" title="查看课件" :titleImg="ckkj"></TitleInfo>
      <el-row
        class="p20"
        :style="isStandalone ? 'min-height: calc(100vh - 38px);overflow: hidden;' : 'min-height: 320px;overflow: auto;'"
      >
        <el-col :span="isStandalone ? 24 : 19">
          <!-- 可拖动浮层容器：按住标题栏可拖动到任意位置，双击标题栏或点按钮还原 -->
          <div
            class="floatWrap"
            :class="{ isFloat: floatState.floating }"
            ref="floatWrap"
            :style="floatStyle"
          >
            <div
              class="floatBar"
              v-show="!isStandalone"
              @mousedown="onDragStart"
              @dblclick="resetFloat"
            >
              <span class="floatBarTitle">
                <i class="el-icon-rank"></i>
                资源预览（按住标题栏拖动，双击还原）
              </span>
              <el-button size="mini" type="text" class="floatBtn" @click="toggleFloat">{{ floatState.floating ? "还原位置" : "设为浮层" }}</el-button>
              <el-button size="mini" type="text" class="floatBtn floatBtnSplit" @click="openSecondScreen">双屏演示</el-button>
            </div>
          <el-row
            v-if="show.load"
            class="showBox tc"
            style="display: flex;justify-content:center;align-items:center;"
          >
            <i class="el-icon-loading font30"></i>
          </el-row>
          <el-row v-show="show.PDFShow" class="showBox">
            <lookPdf
              v-if="!$isEmpty(show.PDFUrl)"
              :pdfUrl="show.PDFUrl"
            ></lookPdf>
            <!-- <VuePdf v-if="show.PDFShow" :pdfUrl="show.PDFUrl"></VuePdf> -->
            <!-- <iframe id="iframe" :src='show.PDFUrl+"#toolbar=0"' width='100%' height='100%' frameborder='1'></iframe>
            <a class="qpclass" v-if="!PdfFullScreenShow" @click="fullScreen()">全屏</a>
            <a class="qpclass" v-else @click="quitFullScreen()">退出</a> -->
          </el-row>
          <!-- 视频查看 -->
          <el-row v-show="show.mp4Show" class="showBox">
            <video
              @timeupdate="onTimeupdate"
              id="myVideo"
              style="width: 100%;height: 100%;"
              class="video-js vjs-default-skin vjs-big-play-centered"
              x-webkit-airplay="allow"
              poster=""
              webkit-playsinline
              playsinline
              x5-video-player-type="h5"
              x5-video-player-fullscreen="true"
              preload="auto"
            >
              <source type="application/x-mpegURL" />
            </video>
          </el-row>
          <el-row v-show="show.fileShow" class="showBox">
            <iframe
              id="InformationURL"
              :src="show.fileUrl"
              width="100%"
              height="100%"
              frameborder="1"
            ></iframe>
          </el-row>
          <el-row
            v-show="show.imgShow"
            class="showBox"
            style="padding: 20px;overflow: auto;"
          >
            <h2 style="text-align: center;">{{ show.imgTitle }}</h2>
            <el-row v-html="show.imgUrl"></el-row>
          </el-row>
          </div>
        </el-col>
        <el-col :span="5" v-show="!isStandalone">
          <el-row
            style="width: 100%;height: calc(100vh - 220px);border: 1px solid #D3D3D3;"
          >
            <el-row
              style="background-color: #EFF2F7;text-align: center;line-height: 40px;font-weight: bold;"
              >目录</el-row
            >
            <el-row
              style="height: calc(100vh - 260px);overflow-y: auto;font-size: 12px;"
            >
              <el-tree
                :data="data"
                ref="tree"
                node-key="teacherOpenCourseMergeCourseInfoId"
                :default-expanded-keys="onIdList"
                :default-checked-keys="[onId]"
                icon-class="el-icon-arrow-right"
                :highlight-current="true"
                :props="defaultProps"
                @node-click="handleNodeClick"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <label>
                    <!-- 1	视频 2	PPT 3	PDF 4	链接 5	图文 -->
                    <template v-if="data.resourcesInfoType != null">
                      <span
                        style="border: 1px solid #5464FF;font-size: 12px;padding: 2px 5px;"
                        >{{ $retRresourcesName(data.resourcesInfoType) }}</span
                      >
                    </template>
                    {{ node.label }}
                  </label>
                </span>
              </el-tree>
            </el-row>
          </el-row>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
import TitleInfo from "@/components/TitleInfo"; //页面头部
import lookPdf from "@/components/lookPdf"; //引入PDF查看器
import jQuery from "jquery";
// import VuePdf from "@/components/VuePdf/index"; //PDF预览
export default {
  name: "CoursewareViewing",
  components: {
    TitleInfo,
    lookPdf
  },
  data() {
    return {
      ckkj: require("../../images/course/ckkj@2x.png"),
      data: [],
      courseId: this.$route.query.courseId,
      onId: this.$route.query.onId,
      onIdList: [], //默认展开的[id]
      courseType: this.$route.query.courseType, //课程类型2:授权课
      defaultProps: {
        children: "children",
        label: "courseInfoName",
        type: "resourcesInfoType"
      },
      player: null,
      show: {
        load: true,
        PDFShow: false,
        PDFUrl: "",
        mp4Show: false,
        mp4Url: "",
        fileShow: false,
        fileUrl: "",
        imgShow: false,
        imgUrl: "",
        imgTitle: "",
        httpShow: false,
        httpUrl: ""
      },
      courseInfoName: null,
      timeIn: null,
      // 资源区浮层拖动状态
      floatState: {
        floating: false, //是否处于浮层状态
        x: 0, //浮层left（px）
        y: 0, //浮层top（px）
        width: 0 //浮层宽度（px）
      },
      dragInfo: null, //拖动过程信息（起点偏移）
      visibleMap: {}, //教师设置的节可见范围 {[节ID]:0或1}，缺省可见
      isStandalone: this.$route.query.standalone == 1, //true=副屏独立窗口，只渲染预览区
      previewWin: null, //副屏窗口句柄
      syncChannel: null, //主副窗通信通道
      syncTimer: null, //轮询副窗是否被关闭
      currentNode: null //当前展示的资源节点，供副窗补发
    };
  },
  computed: {
    // 主副窗共用的广播频道名，按课程区分，避免同浏览器多课程串台
    channelName() {
      return "coursePreview_" + this.courseId;
    },
    // 浮层定位样式：仅浮层状态下脱离文档流
    floatStyle() {
      if (!this.floatState.floating) {
        return {};
      }
      return {
        position: "fixed",
        left: this.floatState.x + "px",
        top: this.floatState.y + "px",
        width: this.floatState.width + "px",
        zIndex: 2000
      };
    }
  },
  created() {
    //读取教师端设置的节可见范围：优先后端 getVisible.do（跨浏览器生效），加载期/失败时回退 sessionStorage 旧契约
    this.visibleMap =
      this.$ls.get(this.$getKeyInfo("courseVisible_" + this.courseId)) || {};
    this.$post("/api/teacherOpenCourseMergeCourseInfo/getVisible.do", {
      teacherOpenCourseId: this.courseId
    }).then(ret => {
      if (ret.code == 0) {
        //服务端为最终数据源：map 里值为 0 = 不可见，未出现的节 = 可见
        this.visibleMap = ret.data || {};
      }
    }).catch(() => {});
    this.getInfo();
    //主副窗通信：副窗打开后自己订阅，主窗收到 ready 再补发当前资源
    this.initSync();
    this._onUnload = () => {
      //关页面/关标签时 Vue 生命周期不会走完，这里兜底：主窗关掉副窗，副窗通知主窗复位
      if (this.isStandalone) {
        this.broadcast({ type: "closed" });
      } else if (this.previewWin && !this.previewWin.closed) {
        try {
          this.broadcast({ type: "close" });
          this.previewWin.close();
        } catch (e) {}
      }
    };
    window.addEventListener("beforeunload", this._onUnload);
    if (this.isStandalone) {
      this.$nextTick(() => this.broadcast({ type: "ready" }));
    }
    this.$nextTick(() => {
      //this.addSystem();
    });
  },
  mounted() {
    this.initVideo();
  },
  methods: {
    getInfo() {
      //获取列表
      if (this.courseType == 2) {
        let url = "/api/courseInfo/getCourseCenterResources.do";
        this.$get(url, { courseInfoId: this.courseId }).then(ret => {
          if (ret.code == 0) {
            let courseInfoAllData = ret.data;
            let zjList = [],
              zNum = 0; //章节
            let xjList = {}; //小节
            let kjList = []; //课件
            courseInfoAllData.forEach((item, index) => {
              if (item.courseInfoType == 2) {
                //章
                zNum++;
                item.courseInfoNo = this.$numberfilter(Number(zNum));
                item.teacherOpenCourseMergeCourseInfoId = item.courseInfoId;
                zjList.push(item);
              }
              if (item.courseInfoType == 3) {
                //节 resourcesInfo：课件
                //保留接口原始的开课目录ID（若返回了），过滤时两套ID都尝试匹配
                item.mergeCourseInfoId = item.teacherOpenCourseMergeCourseInfoId;
                item.teacherOpenCourseMergeCourseInfoId = item.courseInfoId;
                //教师设为不可见的节不显示（学生只读，无修改入口）
                if (!this.isSectionVisible(item.teacherOpenCourseMergeCourseInfoId, item.mergeCourseInfoId)) {
                  return;
                }
                if (
                  this.$isEmpty(xjList[item.courseInfoParentId]) ||
                  xjList[item.courseInfoParentId].length <= 0
                ) {
                  xjList[item.courseInfoParentId] = [];
                  item.courseInfoNo =
                    xjList[item.courseInfoParentId].length + 1;
                  item.children = item.resourcesInfo;
                  xjList[item.courseInfoParentId].push(item);
                } else {
                  item.courseInfoNo =
                    xjList[item.courseInfoParentId].length + 1;
                  item.children = item.resourcesInfo;
                  xjList[item.courseInfoParentId].push(item);
                }
              }
            });
            zjList.forEach((item, index) => {
              item.children = xjList[item.courseInfoId];
              if (!this.$isEmpty(item.children)) {
                item.children.forEach((it, ind) => {
                  if (!this.$isEmpty(it.children)) {
                    this.onIdList.push(it.teacherOpenCourseMergeCourseInfoId);
                    it.children.forEach((itt, indx) => {
                      itt.courseInfoType = 4;
                      itt.courseInfoName = itt.resourcesInfoName;
                      itt.teacherOpenCourseMergeCourseInfoId =
                        10000 + Number(itt.resourcesInfoId);
                      // item.children[index].children[ind].children[indx].teacherOpenCourseMergeCourseInfoId = 10000 + it.resourcesInfoId;
                    });
                  }
                });
              }
            });
            this.data = zjList;

            setTimeout(() => {
              this.$refs["tree"].setCurrentKey(this.onId);
              this.show.load = false;
              this.handleNodeClick(this.$refs.tree.getCurrentNode());
            }, 10);
          }
        });
      } else {
        this.$post(
          "/api/teacherOpenCourseMergeCourseInfo/getTreeByTeacherOpenCourseId.do",
          { teacherOpenCourseId: this.courseId }
        ).then(ret => {
          if (ret.code == 0) {
            if (!this.$isEmpty(ret.data)) {
              //教师设为不可见的节不显示（children=章，章的children=节）
              if (!this.$isEmpty(ret.data.children)) {
                ret.data.children.forEach(zj => {
                  if (!this.$isEmpty(zj.children)) {
                    zj.children = zj.children.filter(
                      xj =>
                        this.isSectionVisible(
                          xj.teacherOpenCourseMergeCourseInfoId
                        )
                    );
                  }
                });
              }
              this.data = ret.data.children;
              this.courseInfoName = ret.data.courseInfoName;
            }
          }
          if (ret.code == 0) {
            if (!this.$isEmpty(ret.data)) {
              this.data = ret.data.children;
              for (let item in this.data) {
                //处理resourcesInfo[] 资源数据匹配入
                for (let it in this.data[item].children) {
                  this.data[item].children[it].children = this.data[
                    item
                  ].children[it].resourcesInfo;
                  this.onIdList.push(
                    this.data[item].children[it]
                      .teacherOpenCourseMergeCourseInfoId
                  );
                  for (let i in this.data[item].children[it].children) {
                    this.data[item].children[it].children[i].courseInfoType = 4;
                    this.data[item].children[it].children[
                      i
                    ].courseInfoName = this.data[item].children[it].children[
                      i
                    ].resourcesInfoName;
                    this.data[item].children[it].children[
                      i
                    ].teacherOpenCourseMergeCourseInfoId =
                      this.data[item].children[it].children[i]
                        .teacherOpenCourseMergeCourseInfoId +
                      this.data[item].children[it].children[i]
                        .teacherOpenCourseMergeResourcesInfoId;
                  }
                }
              }
              setTimeout(() => {
                this.$refs["tree"].setCurrentKey(this.onId);
                this.show.load = false;
                this.handleNodeClick(this.$refs.tree.getCurrentNode());
              }, 10);
            }
          }
        });
      }
    },
    handleNodeClick(data) {
      //树节点点击：主窗渲染后把资源推给副屏（副窗只接收，不回推，避免来回广播）
      this.currentNode = data;
      this.renderResource(data);
      if (!this.isStandalone) {
        this.broadcast({ type: "play", payload: this.pickNode(data) });
      }
    },
    applyRemote(payload) {
      //副窗收到主窗的资源切换
      if (this.$isEmpty(payload)) return;
      this.currentNode = payload;
      this.renderResource(payload);
    },
    renderResource(data) {
      if (this.$isEmpty(data)) return;
      //1	视频 2	PPT 3	PDF 4	链接 5	图文
      if (!this.$isEmpty(this.player)) {
        //停止
        this.player.pause();
      }
      if (data.courseInfoType == 4) {
        if (data.resourcesInfoType == 4) {
          let link =
            data.resourcesInfoContent.indexOf("http") == 0
              ? data.resourcesInfoContent
              : "http://" + data.resourcesInfoContent;
          if (this.isStandalone) {
            window.location.href = link; //副屏窗口自己跳转，避免又弹一个窗口回到主屏
          } else {
            window.open(link);
          }
          return;
        }
        this.show.mp4Show = data.resourcesInfoType == 1 ? true : false;
        this.show.fileShow = data.resourcesInfoType == 2 ? true : false;
        this.show.PDFShow = data.resourcesInfoType == 3 ? true : false;
        this.show.imgShow = data.resourcesInfoType == 5 ? true : false;
        if (data.resourcesInfoType == 1) {
          this.player.src({
            src: this.$processUrl(data.resourcesInfoContent),
            type:
              data.resourcesInfoContent.indexOf(".mp4") >= 0
                ? "video/mp4"
                : "video/webm"
          });
          this.player.play(); //播放
        } else if (data.resourcesInfoType == 2) {
          if (
            data.resourcesInfoContent.indexOf(".pdf") >= 0 ||
            data.resourcesInfoContent.indexOf(".PDF") >= 0
          ) {
            this.show.PDFUrl = this.$processUrl(data.resourcesInfoContent);
            this.show.fileShow = false;
            this.show.PDFShow = true;
          } else {
            this.show.fileUrl =
              this.$viewUrl + this.$processUrl(data.resourcesInfoContent);

            this.show.fileShow = true;
            this.show.PDFShow = false;
          }
        } else if (data.resourcesInfoType == 3) {
          this.show.PDFUrl = this.$processUrl(data.resourcesInfoContent);
        } else if (data.resourcesInfoType == 5) {
          this.show.imgUrl = data.resourcesInfoContent;
          this.show.imgTitle = data.resourcesInfoName;
        }
      }
    },
    // 判断节是否对当前班级可见（教师端设为0则隐藏，缺省可见）
    // 兼容两套ID体系：开课目录用 teacherOpenCourseMergeCourseInfoId；课程中心(courseType=2)用 courseInfoId，
    // 任一命中且值为 0 即隐藏，都没命中则可见
    isSectionVisible(xjId, altId) {
      if (this.$isEmpty(this.visibleMap)) {
        return true;
      }
      let hit = false;
      let hidden = false;
      [xjId, altId].forEach(id => {
        if (this.$isEmpty(id)) return;
        let v = this.visibleMap[id];
        if (v !== undefined && v !== null) {
          hit = true;
          if (Number(v) === 0) hidden = true;
        }
      });
      return hit ? !hidden : true;
    },
    // 浮层与文档流切换
    toggleFloat() {
      if (!this.floatState.floating) {
        //记录当前渲染位置和宽度，转浮层后保持视觉不跳动
        let rect = this.$refs.floatWrap.getBoundingClientRect();
        this.floatState.x = rect.left;
        this.floatState.y = rect.top;
        this.floatState.width = rect.width;
        this.floatState.floating = true;
      } else {
        this.resetFloat();
      }
    },
    // 还原浮层到文档流原位
    resetFloat() {
      this.floatState.floating = false;
      this.floatState.x = 0;
      this.floatState.y = 0;
      this.floatState.width = 0;
    },
    // 按下标题栏开始拖动
    onDragStart(e) {
      if (e.button !== 0) {
        return;
      }
      if (!this.floatState.floating) {
        //非浮层状态先进入浮层再拖动
        this.toggleFloat();
      }
      let rect = this.$refs.floatWrap.getBoundingClientRect();
      this.dragInfo = {
        offX: e.clientX - rect.left,
        offY: e.clientY - rect.top
      };
      document.body.style.userSelect = "none"; //拖动中禁止选中文本
      document.addEventListener("mousemove", this.onDragMove);
      document.addEventListener("mouseup", this.onDragEnd);
    },
    // 拖动中：更新位置并限制在视口内
    onDragMove(e) {
      if (this.$isEmpty(this.dragInfo)) {
        return;
      }
      let rect = this.$refs.floatWrap.getBoundingClientRect();
      let maxX = Math.max(window.innerWidth - rect.width, 0);
      let maxY = Math.max(window.innerHeight - rect.height, 0);
      this.floatState.x = Math.min(Math.max(e.clientX - this.dragInfo.offX, 0), maxX);
      this.floatState.y = Math.min(Math.max(e.clientY - this.dragInfo.offY, 0), maxY);
    },
    // 拖动结束：解绑document事件
    onDragEnd() {
      this.dragInfo = null;
      document.body.style.userSelect = "";
      document.removeEventListener("mousemove", this.onDragMove);
      document.removeEventListener("mouseup", this.onDragEnd);
    },
    /* ==================== 双屏演示（独立窗口） ==================== */
    openSecondScreen() {
      if (this.previewWin && !this.previewWin.closed) {
        this.previewWin.focus();
        return;
      }
      //必须在点击事件里同步开窗：任何 await 之后再 open 都会被浏览器判定为无手势而拦截
      let win = window.open(
        "about:blank",
        "coursePreview_" + this.courseId,
        "width=1280,height=800,menubar=no,toolbar=no,location=no,status=no"
      );
      if (!win) {
        this.$message({
          message: "新窗口被浏览器拦截，请允许本站弹出窗口后重试",
          type: "warning"
        });
        return;
      }
      this.previewWin = win;
      try {
        win.document.title = "课件预览";
      } catch (e) {}
      //先加载内容再调整位置：授权弹窗可能停留几秒，避免副屏窗口长时间空白
      win.location.href = this.buildStandaloneUrl();
      this.moveToSecondScreen(win);
      this.startPreviewWatch();
      this.$message({
        message: "已打开双屏窗口：可直接拖到副屏，或点窗口内「全屏」",
        type: "success"
      });
    },
    buildStandaloneUrl() {
      //沿用当前完整地址（含 courseId / onId / courseType），去掉旧的 standalone 再补一个
      let href = window.location.href
        .replace(/([?&])standalone=[^&]*/g, "$1")
        .replace(/[?&](?=#|$)/g, "");
      //副窗是全新上下文，URL 上没有 _role_tag 就必须补回，否则所有接口 401 并跳登录
      let tag = this.$getRoleTag ? this.$getRoleTag() : "";
      if (!this.$isEmpty(tag) && href.indexOf("_role_tag=") < 0) {
        href += (href.indexOf("?") >= 0 ? "&" : "?") + "_role_tag=" + tag;
      }
      return href + (href.indexOf("?") >= 0 ? "&" : "?") + "standalone=1";
    },
    moveToSecondScreen(win) {
      //有扩展屏就搬到副屏；不支持 Window Management API 或用户拒绝授权时保持默认位置，由老师手动拖
      try {
        if (!window.screen || !window.screen.isExtended || !window.getScreenDetails) {
          return;
        }
        window
          .getScreenDetails()
          .then(detail => {
            let screens = (detail && detail.screens) || [];
            let current = detail.currentScreen;
            let second = screens.filter(s => s !== current)[0];
            if (!second || !win || win.closed) return;
            win.moveTo(second.availLeft, second.availTop);
            win.resizeTo(second.availWidth, second.availHeight);
          })
          .catch(() => {});
      } catch (e) {}
    },
    initSync() {
      //BroadcastChannel 同源广播：副窗刷新后重新订阅即可，不依赖 opener 引用
      if (typeof BroadcastChannel === "undefined") return;
      this.syncChannel = new BroadcastChannel(this.channelName);
      this.syncChannel.onmessage = e => {
        let msg = e.data || {};
        if (this.isStandalone) {
          if (msg.type === "play") this.applyRemote(msg.payload);
          if (msg.type === "close") this.closeStandalone();
          return;
        }
        if (msg.type === "ready") this.pushCurrentToScreen(); //副窗就绪，补发当前资源
        if (msg.type === "closed") this.clearPreviewWin();
      };
    },
    broadcast(msg) {
      if (!this.syncChannel) return;
      try {
        this.syncChannel.postMessage(msg);
      } catch (e) {}
    },
    pushCurrentToScreen() {
      if (!this.$isEmpty(this.currentNode)) {
        this.broadcast({ type: "play", payload: this.pickNode(this.currentNode) });
      }
    },
    pickNode(data) {
      //只传渲染必需字段，避免整棵节点（含 resourcesInfo 全量）在两个窗口间复制
      if (!data) return null;
      return {
        courseInfoType: data.courseInfoType,
        resourcesInfoType: data.resourcesInfoType,
        resourcesInfoContent: data.resourcesInfoContent,
        resourcesInfoName: data.resourcesInfoName,
        teacherOpenCourseMergeCourseInfoId:
          data.teacherOpenCourseMergeCourseInfoId
      };
    },
    startPreviewWatch() {
      this.stopPreviewWatch();
      this.syncTimer = setInterval(() => {
        if (this.previewWin && this.previewWin.closed) {
          this.clearPreviewWin();
          this.$message({ message: "双屏窗口已关闭", type: "info" });
        }
      }, 1000);
    },
    stopPreviewWatch() {
      if (this.syncTimer) {
        clearInterval(this.syncTimer);
        this.syncTimer = null;
      }
    },
    clearPreviewWin() {
      this.stopPreviewWatch();
      this.previewWin = null;
    },
    toggleFullscreen() {
      let el = document.documentElement;
      let isFull = document.fullscreenElement || document.webkitFullscreenElement;
      if (!isFull) {
        if (el.requestFullscreen) el.requestFullscreen();
        else if (el.webkitRequestFullscreen) el.webkitRequestFullscreen();
      } else {
        if (document.exitFullscreen) document.exitFullscreen();
        else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
      }
    },
    closeStandalone() {
      this.broadcast({ type: "closed" });
      //只有脚本打开的窗口才允许 close()，直接访问时退化为返回上一页
      window.close();
      setTimeout(() => {
        if (!window.closed) window.history.back();
      }, 200);
    },
    initVideo() {
      let this_ = this;
      this.player = this.$video(
        myVideo,
        {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: false,
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          autoDisable: true,
          //设置视频播放器的显示宽度（以像素为单位）
          // playbackRates: [0.5, 1, 1.5, 2],
          sources: [
            // 视频源
            {
              src: "../../../static/jl.mp4",
              poster: "",
              type: this.$isEmpty(this.mp4Url)
                ? ""
                : this.mp4Url.indexOf(".mp4") >= 0
                ? "video/mp4"
                : "video/webm"
            }
          ]
        },
        function onPlayerReady() {
          //this_.player.currentTime(5); //指定视频的开始播放位置
        }
      );
    },
    onTimeupdate(e) {
      //判断是否播放完成
    },
    addSystem() {
      //模块使用统计
      //模块使用时间 开始
      const timeNum = this.$ls.get("timeNum"); //获取统一
      this.timeIn = setInterval(() => {
        let param = {
          firstName: "课程中心", //一级名称
          secondName: this.courseInfoName, //二级名称
          useDuration: timeNum / 1000 / 60 //单次使用时长（单位：分钟）
        };
        this.$addSystemUseLog(param);
      }, timeNum);
      // 结束
    }
  },
  beforeDestroy() {
    clearInterval(this.timeIn); //关闭定时
    //解绑document上的拖动事件，防止内存泄漏
    this.dragInfo = null;
    document.body.style.userSelect = "";
    document.removeEventListener("mousemove", this.onDragMove);
    document.removeEventListener("mouseup", this.onDragEnd);
    if (this._onUnload) {
      window.removeEventListener("beforeunload", this._onUnload);
      this._onUnload = null;
    }
    //关闭双屏：主窗离开时顺手关掉副窗，副窗离开时释放定时与通道
    this.stopPreviewWatch();
    if (this.syncChannel) {
      if (!this.isStandalone) this.broadcast({ type: "close" });
      try {
        this.syncChannel.close();
      } catch (e) {}
      this.syncChannel = null;
    }
  }
};
</script>
<style lang="less">
.el-coursewareViewing {
  padding: 20px 20px 0;
  .content_block {
    background-color: #ffffff;
  }
  //双屏演示时副窗顶部工具条
  .standaloneBar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 38px;
    line-height: 38px;
    padding: 0 12px;
    background-color: #eff2f7;
    border-bottom: 1px solid #e1e1e1;
    .sbTitle {
      font-size: 13px;
      color: #303133;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .el-button {
      color: #606266;
      margin-left: 14px;
    }
  }
  //副屏独立窗口：铺满视口，去掉页面留白与页头
  &.standalone {
    padding: 0;
    background-color: #ffffff;
    .content_block {
      margin-bottom: 0 !important;
      background-color: transparent;
    }
    .p20 {
      padding: 0 !important;
    }
    .showBox {
      width: 100%;
      height: calc(100vh - 38px);
      border: none;
    }
  }
  //资源区浮层容器
  .floatWrap {
    position: relative;
    &.isFloat {
      border: 1px solid #5464FF;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
      background-color: #ffffff;
    }
    .floatBar {
      height: 34px;
      line-height: 34px;
      padding: 0 10px;
      background-color: #eff2f7;
      border: 1px solid #e1e1e1;
      border-bottom: none;
      cursor: move;
      font-size: 12px;
      user-select: none;
      .floatBarTitle {
        float: left;
        color: #606266;
        i {
          margin-right: 5px;
        }
      }
      .floatBtn {
        float: right;
        padding: 0;
        line-height: 34px;
        font-size: 12px;
      }
      .floatBtnSplit {
        margin-right: 16px;
        color: #5464ff;
      }
    }
  }
  .showBox {
    width: calc(100% - 20px);
    height: calc(100vh - 220px);
    border: 1px solid #d3d3d3;
    img {
      max-width: 100%;
    }
  }
  .qpclass {
    position: absolute;
    right: 59px;
    width: 40px;
    height: 40px;
    bottom: 1px;
    padding: 2px;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    border-radius: 50%;
    background-color: #f2f2f2;
    color: #616161;
  }
  .el-tree-node__children .el-tree-node__content {
    padding-left: 15px !important;
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/pages/course/CoursewareViewing.vue